import { Swiper, SwiperSlide } from "swiper/react";
import { useNavigate } from "react-router-dom";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { EffectCoverflow, Pagination, Navigation } from "swiper/modules";

import CP from "main/assets/images/png/CP.png";
import JP from "main/assets/images/png/JP.png";
import OP from "main/assets/images/png/OP.png";
import RP from "main/assets/images/png/RP.png";
import SM from "main/assets/images/png/SM.png";
import SP from "main/assets/images/png/SP.png";
import Y from "main/assets/images/png/Y.png";
import YLogo from "main/assets/images/png/YLogo.png";
import YantraLogo from "main/assets/images/png/YantraLogo.png";
import Left from "main/assets/images/png/Left.png";
import Right from "main/assets/images/png/Right.png";

function PlatformSlider() {
  const navigate = useNavigate();
  return (
    <>
      {/* website */}
      <div className="d-none d-md-block">
        <div className="d-flex justify-content-center align-items-center flex-column py-30 px-40">
          <div className="header-color font-30 fonts-800 mb-10 font-family-roboto line-35 align-items-center para-heading py-10">
            Yantr.ai Offerings
          </div>
          <div className="w-100">
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              loop={true}
              slidesPerView={"auto"}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 80,
                modifier: 2.0,
              }}
              pagination={{ el: ".swiper-pagination", clickable: true }}
              navigation={{
                nextEl: ".swiper-button-nex",
                prevEl: ".swiper-button-pre",
              }}
              modules={[EffectCoverflow, Pagination, Navigation]}
              className="swiper_container platform_containter"
            >
              <SwiperSlide>
                <div style={{ position: "relative" }}>
                  <img src={Y} alt="slide_image" />
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 50,
                      bottom: 0,
                      margin: "auto",
                    }}
                  >
                    <div className="mt-30">
                      <img src={YLogo} alt="Ylogo" />
                    </div>
                    <div className="mt-20">
                      <img
                        style={{ width: "auto", height: "40px" }}
                        src={YantraLogo}
                        alt="YantraLogo"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/jeopardy-management")}
                >
                  <img src={JP} alt="slide_image" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Jeopardy Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                        borderRadius: "15px",
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10">
                        Jeopardy Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-40 pb-3">
                        Get recommendations for triage and jeopardy tickets in
                        real time for prioritization and SLA adherence.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/route-mapping")}
                >
                  <img src={RP} alt="slide_image" />
                  <div className="vertical-text slider-heading d-block  border-platform">
                    Route Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                        borderRadius: "15px",
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10">
                        Route Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-20 pb-3">
                        AI based routing optimization to minimize cost and meet
                        delivery timelines and reducing carbon footprint.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/scenario-modelling")}
                >
                  <img src={SM} alt="slide_image" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Scenario Modeling
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10 ">
                        Scenario Modeling
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-30 pb-3">
                        Extreme event simulation engine on real world parameters
                        to gauge cost benefit of multiple scenarios.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/operational-planning")}
                >
                  <img src={OP} alt="slide_image" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Operational Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10">
                        Operational Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-40 pb-3">
                        Control Tower view with proactive alert system for
                        future demand and supply management.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/strategic-planning")}
                >
                  <img src={SP} alt="slide_image" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Strategic Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10">
                        Strategic Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-40 pb-3">
                        Capacity optimization with cross skilling, and
                        relocations and hiring with visibility up to 12 months.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/capacity-planning")}
                >
                  <img src={CP} alt="slide_image" />

                  <div className="vertical-text slider-heading text-black-10 d-block border-platform">
                    Capacity Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-26 line-30 text-black-10 py-10 ">
                        Capacity Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-40 pb-3">
                        AI driven forecasting factoring external events for
                        better management of supply.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <div className="z-index-1 slider-controler d-flex m-auto p-auto w-100 justify-content-center position-absolute bottom-4">
                <div className="swiper-button-pre slider-arrow mr-25">
                  <img src={Left} alt="left-img" />
                </div>
                <div className="swiper-button-nex slider-arrow">
                  <img src={Right} alt="right-img" />
                </div>
              </div>
            </Swiper>
          </div>
        </div>
      </div>
      {/* Mobile */}
      <div className="d-block d-md-none">
        <div className="d-flex justify-content-center align-items-center flex-column py-20 px-0">
          <div className="header-color font-30 fonts-800 mb-10 font-family-roboto line-35 align-items-center para-heading py-15">
            Yantr.ai Offerings
          </div>
          <div className="w-100">
            <Swiper
              effect={"coverflow"}
              grabCursor={true}
              centeredSlides={true}
              loop={true}
              slidesPerView={"auto"}
              coverflowEffect={{
                rotate: 0,
                stretch: 0,
                depth: 80,
                modifier: 2.0,
              }}
              pagination={{ el: ".swiper-pagination", clickable: true }}
              navigation={{
                nextEl: ".swiper-button-nex",
                prevEl: ".swiper-button-pre",
              }}
              modules={[EffectCoverflow, Pagination, Navigation]}
              className="swiper_container platform_containter"
            >
              <SwiperSlide>
                <div style={{ position: "relative" }}>
                  <img src={Y} alt="slide_image" className="slidercoverimg" />
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      right: 0,
                      top: 50,
                      bottom: 0,
                      margin: "auto",
                    }}
                  >
                    <div className="">
                      <img src={YLogo} alt="Ylogo" className="silderYimg" />
                    </div>
                    <div className="">
                      <img
                        className="silderimg"
                        //style={{ width: "50px", height: "120px" }}
                        src={YantraLogo}
                        alt="YantraLogo"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/jeopardy-management")}
                >
                  <img src={JP} alt="slide_image" className="slidercoverimg" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Jeopardy Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 text-black-10 pt-200 py-2">
                        Jeopardy Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        Get recommendations for triage and jeopardy tickets in
                        real time for prioritization and SLA adherence.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/route-mapping")}
                >
                  <img src={RP} alt="slide_image" className="slidercoverimg" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Route Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 text-black-10 pt-200 py-2">
                        Route Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        AI based routing optimization to minimize cost and meet
                        delivery timelines and reducing carbon footprint.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/scenario-modelling")}
                >
                  <img src={SM} alt="slide_image" className="slidercoverimg" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Scenario Modeling
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 text-black-10 pt-200 py-2">
                        Scenario Modeling
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        Extreme event simulation engine on real world parameters
                        to gauge cost benefit of multiple scenarios.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/operational-planning")}
                >
                  <img src={OP} alt="slide_image" className="slidercoverimg" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Operational Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 pt-200 text-black-10 py-2">
                        Operational Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        Control Tower view with proactive alert system for
                        future demand and supply management.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/strategic-planning")}
                >
                  <img src={SP} alt="slide_image" className="slidercoverimg" />
                  <div className="vertical-text slider-heading d-block border-platform">
                    Strategic Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 text-black-10 pt-200 py-2">
                        Strategic Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        Capacity optimization with cross skilling, and
                        relocations and hiring with visibility up to 12 months.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div
                  style={{ position: "relative" }}
                  onClick={() => navigate("/capacity-planning")}
                >
                  <img src={CP} alt="slide_image" className="slidercoverimg" />

                  <div className="vertical-text slider-heading text-black-10 d-block border-platform">
                    Capacity Planning
                  </div>
                  <div className="position-absolute bottom-0 slider-description d-none">
                    <div
                      className="bottom-border"
                      style={{
                        background: `linear-gradient(to bottom, rgba(255, 255, 255, 0.05), #fff)`,
                      }}
                    >
                      <div className="font-family-roboto-flex fonts-800 font-22 line-30 text-black-10 pt-200 py-2">
                        Capacity Planning
                      </div>
                      <div className="m-auto p-auto text-black-10 font-family-roboto fonts-400 font-14 line-16 justify-content-center px-1 pb-2">
                        AI driven forecasting factoring external events for
                        better management of supply.
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <div className="z-index-1 slider-controler d-flex m-auto p-auto w-100 justify-content-center position-absolute bottom-2">
                <div className="swiper-button-pre slider-arrow mr-25">
                  <img src={Left} alt="left-img" />
                </div>
                <div className="swiper-button-nex slider-arrow">
                  <img src={Right} alt="right-img" />
                </div>
              </div>
            </Swiper>
          </div>
        </div>
      </div>
    </>
  );
}

export default PlatformSlider;
